



































import i18n from 'vue-i18n';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
export default {
    name: 'CoStreamUpdatesIndicator',
    i18n: {
        messages: {
            en: {
                labels: {
                    oneNewPost: 'New post',
                    multipleNewPosts: '{count} New Posts',
                },
            },
            de: {
                labels: {
                    oneNewPost: 'Neuer Beitrag',
                    multipleNewPosts: '{count} Neue Beiträge',
                },
            },
        },
    },
    components: {
        CoButton,
    },
    props: {
        count: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            default: 'chevron-up',
        },
    },
    computed: {
        buttonLabel() {
            if (this.count === 1) {
                return this.$t('labels.oneNewPost');
            }

            return this.$t('labels.multipleNewPosts', { count: this.count });
        },
    },
};
